/**
 * 开发环境日志工具
 * 在生产环境中会被完全移除，不会被打包
 */

// 检查是否为开发环境
const isDev = process.env.NODE_ENV === 'development'

// 开发环境日志函数
const devLog = (...args) => {
  if (isDev) {
    console.log('[调试]', ...args)
  }
}

const devWarn = (...args) => {
  if (isDev) {
    console.warn('[转盘警告]', ...args)
  }
}

const devError = (...args) => {
  if (isDev) {
    console.error('[转盘错误]', ...args)
  }
}

const devInfo = (...args) => {
  if (isDev) {
    console.info('[转盘信息]', ...args)
  }
}

// 角度调试专用函数
const logAngle = (angle, label = '角度') => {
  if (isDev) {
    console.log(`[角度调试] ${label}:`, angle, '°')
  }
}

// 转盘状态调试
const logWheelState = (state) => {
  if (isDev) {
    console.log('[转盘状态]', state)
  }
}

// 动画调试
const logAnimation = (phase, data) => {
  if (isDev) {
    console.log(`[动画${phase}]`, data)
  }
}

// 导出日志工具
export {
  devLog,
  devWarn,
  devError,
  devInfo,
  logAngle,
  logWheelState,
  logAnimation
}

// 默认导出
export default {
  log: devLog,
  warn: devWarn,
  error: devError,
  info: devInfo,
  angle: logAngle,
  wheelState: logWheelState,
  animation: logAnimation
}
